import { useNewCode } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { FilterMenuFooter } from '@calendly/ui/components/filter-menu';
import { Grid, GridItem } from '@calendly/ui/components/grid';
import { Loader } from '@calendly/ui/components/loader';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { MeetingsFilterMenuContent } from 'components/cui_filter_menu';
import { Error } from './components/error';
import { presetFilterFooterCss, presetFilterGridCss, presetFilterScrollBodyCss } from './preset_filter_sheet_styles';
const meetingsFilterContentCss = "m1a84ye7";
const gridWrapperUseNewPaddingCss = "g1tte82g";
const gridBodyCss = "g4czil3";
const GridBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    useNewPadding = false,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(gridBodyCss, {
    [gridWrapperUseNewPaddingCss]: useNewPadding
  }, props.className)} />;
});
const meetingsFilterFooterCss = "muc8eb5";
const actionsContainerIsPhoneCss = "a11n016t";
const actionsContainerCss = "ak8z21x";
const ActionsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(actionsContainerCss, {
    [actionsContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const buttonTextWrapperIsPhoneCss = "b1t23cq0";
const buttonTextWrapperCss = "b7jvh8u";
const ButtonTextWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(buttonTextWrapperCss, {
    [buttonTextWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const viewMoreButtonCss = "v1mx23fe";
const ViewMoreButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(viewMoreButtonCss, props.className)} />);
const clearButtonIsPhoneCss = "c1o0nb3g";
const clearButtonCss = "c15f01vh";
const ClearButton = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <BareButton ref={ref} {...props} className={classNames(clearButtonCss, {
    [clearButtonIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const BaseFilterModal = ({
  onClose,
  onApply,
  onClear,
  hasError,
  advancedFilters,
  isResultsLoading,
  resultCount,
  alwaysShowAdvanced = false,
  fullScreenSheet = false,
  children
}) => {
  const isPhone = useDeviceType('isPhone');
  const [showMore, setShowMore] = useState(!!isPhone || alwaysShowAdvanced);
  const useSaFilterSettingsFlag = useNewCode('sa_filter_settings_mtg_pg', false)?.enabled;
  const showAdvancedFilters = useSaFilterSettingsFlag || alwaysShowAdvanced;
  return <MeetingsFilterMenuContent aria-label={I18n.t('publisher.meetings.filter_modal.label')} className={fullScreenSheet ? undefined : meetingsFilterContentCss} contentTestId="meetings-filter-menu-content" footer={<FilterMenuFooter className={fullScreenSheet ? presetFilterFooterCss : meetingsFilterFooterCss}>
          {isResultsLoading ? <Loader size="small" /> : <BodyText color="muted">
                {I18n.t('publisher.meetings.filter_modal.results', {
        count: resultCount
      })}
              </BodyText>}
          <ActionsContainer>
            {!fullScreenSheet && <ClearButton decoration="minimal" onClick={onClear}>
                {isPhone ? I18n.t('publisher.action.reset') : I18n.t('publisher.meetings.filter_modal.reset')}
              </ClearButton>}
            <Button onClick={onClose} decoration="secondary-outline">
              <ButtonTextWrapper>
                {I18n.t('publisher.action.cancel')}
              </ButtonTextWrapper>
            </Button>
            <Button onClick={onApply}>
              <ButtonTextWrapper>
                {I18n.t('publisher.action.apply')}
              </ButtonTextWrapper>
            </Button>
          </ActionsContainer>
        </FilterMenuFooter>}>
      {hasError && <Error />}
      <GridBody useNewPadding={useSaFilterSettingsFlag && !fullScreenSheet} className={fullScreenSheet ? presetFilterScrollBodyCss : undefined}>
        {/*
          The preset sheet stacks full-width blocks, so disable the CUI grid gutter
          (spacing="0"). The default "8" applies a -8px left margin on the grid plus
          an 8px padding-left on every item, which left the section headers, source
          block, and field rows on inconsistent left edges and widths.
         */}
        <Grid spacing={fullScreenSheet ? '0' : '8'} spacingMobile={fullScreenSheet ? '0' : '8'} className={fullScreenSheet ? presetFilterGridCss : undefined}>
          {children}
          {!showAdvancedFilters && !showMore && <GridItem size="12">
                <ViewMoreButton onClick={() => setShowMore(true)}>
                  {I18n.t('publisher.meetings.filter_modal.expand')}
                </ViewMoreButton>
              </GridItem>}
          {!showAdvancedFilters && showMore && advancedFilters}
          {showAdvancedFilters && advancedFilters}
        </Grid>
      </GridBody>
    </MeetingsFilterMenuContent>;
};

require("./base_filter_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./base_filter_modal.js");